import { triggerStateChangedRequest } from '~core';
import { getState } from '~src/state';
import { clearSelectionsStyles } from '~src/utils';
import { updateTextBorderColorControl } from './updateTextBorderColorControl';

export function changeTextBorderColor(hexColor) {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      clearSelectionsStyles(activeObject, 'stroke');
      activeObject.set('stroke', hexColor);
    } else if (selectionStart === selectionEnd) {
      activeObject.set('stroke', hexColor);
    } else {
      activeObject.setSelectionStyles({
        stroke: hexColor,
      });
    }
  } else {
    clearSelectionsStyles(activeObject, 'stroke');
    activeObject.set('stroke', hexColor);
  }

  window.canvas.renderAll();
  updateTextBorderColorControl();
  triggerStateChangedRequest();
}
